<template>
  <v-card
    v-bind="$attrs"
    v-on="$listeners"
    :class="cardClass"
  >
    <div>
      <v-card
        v-if="!$slots.offset"
        :color="color"
        :class="`elevation-${elevation}`"
        class="v-card--material__header"
        dark
      >
        <slot
          v-if="!title && !text"
          name="header"
        />
        <span v-else>
          <p
            class="headline font-weight-regular mb-2"
            v-text="title"
          />
          <p
            class="category font-weight-thin"
            v-text="text"
          />
        </span>
      </v-card>
    </div>

    <v-card-text>
      <slot />
    </v-card-text>

    <v-divider
      v-if="$slots.actions"
      class="mx-3"
    />

    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'Card',

  inheritAttrs: false,

  props: {
    color: {
      type: String,
      default: 'primary'
    },
    elevation: {
      type: Number,
      default: 0
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    },
    cardClass: {
      type: String,
      default: 'mb-3'
    }
  }
}
</script>
